<template>
	<div class="container-fluid footer-container">
		<div class="container">
			<div class="parent">
				<div class="div1">
					<h4 class="footer-link">© 2007-2024г. ООО «КУРС»
						<br>Все права защищены</h4>
				</div>
				<div class="div2">
					<router-link :to="{name: 'PageViewer', params: {identifier: 'about'}}">
						<h3 class="menu mb-3">Компания</h3>
					</router-link>
					<router-link :to="{name: 'PageViewer', params: {identifier: 'aiiscue'}}">
						<h3 class="menu">АСКУЭ</h3>
					</router-link>
				</div>
				<div class="div3">
					<router-link :to="{name: 'PageViewer', params: {identifier: 'vacBreakers'}}">
						<h3 class="menu mb-3">Каталог</h3>
					</router-link>
					<router-link :to="{name: 'PageViewer', params: {identifier: 'clients'}}">
						<h3 class="menu">Опыт работ</h3>
					</router-link>
				</div>
				<div class="div4">
					<router-link :to="{name: 'PageViewer', params: {identifier: 'activities'}}">
						<h3 class="menu mb-3">Услуги</h3>
					</router-link>
					<router-link :to="{name: 'PageViewer', params: {identifier: 'contacts'}}">
						<h3 class="menu">Контакты</h3>
					</router-link>
				</div>
				<div class="div5">
					<div class="row ">
						<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="25px"
							 height="25px" viewBox="0 0 14.55 15.51" style="enable-background:new 0 0 14.55 15.51;" xml:space="preserve">
						<defs>
						</defs>
						<g class="st0">
							<path class="st1" d="M10.17,15.51c-0.97-0.02-1.88-0.26-2.74-0.68c-1.05-0.52-1.99-1.21-2.83-2.01c-1.2-1.14-2.27-2.38-3.15-3.79
								c-0.56-0.9-1.02-1.84-1.27-2.88c-0.3-1.24-0.24-2.45,0.3-3.63C0.76,1.9,1.2,1.38,1.71,0.93c0.27-0.24,0.54-0.46,0.83-0.68
								c0.47-0.35,0.94-0.33,1.39,0.06C4.3,0.64,4.56,1.05,4.84,1.46c0.3,0.43,0.57,0.89,0.77,1.38c0.33,0.82,0.2,1.37-0.46,1.96
								c-0.24,0.22-0.5,0.43-0.77,0.62C3.83,5.81,3.66,6.28,3.84,6.94C4,7.48,4.28,7.96,4.6,8.41C5.13,9.12,5.7,9.8,6.35,10.4
								c0.43,0.4,0.87,0.77,1.43,0.99c0.56,0.21,1.04,0.13,1.47-0.3c0.29-0.3,0.6-0.59,0.93-0.85c0.53-0.4,1.08-0.44,1.67-0.14
								c0.55,0.28,1.01,0.67,1.46,1.08c0.21,0.19,0.42,0.39,0.63,0.58c0.31,0.29,0.53,0.63,0.6,1.05c0.02,0.14-0.04,0.29-0.1,0.42
								c-0.08,0.17-0.22,0.3-0.35,0.42c-0.44,0.41-0.87,0.83-1.39,1.15c-0.65,0.39-1.36,0.62-2.12,0.69
								C10.45,15.5,10.31,15.51,10.17,15.51z"/>
						</g>
						</svg>
						<span class="phone opacity">+7 (347) </span><span class="phone">216-36-54</span>
					</div>
				<div class="row mt-1" >
					<!-- Generator: Adobe Illustrator 24.0.2, SVG Export Plug-In  -->
					<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px"
						 height="20px" viewBox="0 0 10.89 10.48" style="enable-background:new 0 0 10.89 10.48;" xml:space="preserve" class="ml-2">
						<defs>
						</defs>
						<g class="st0">
							<path class="st1" d="M5.44,0L0,4.05v6.43h10.89V4.05L5.44,0z M3.94,2.89C4.1,2.6,4.32,2.38,4.6,2.23c0.28-0.15,0.6-0.22,0.96-0.22
								c0.3,0,0.57,0.06,0.81,0.18c0.24,0.12,0.42,0.29,0.54,0.5C7.03,2.91,7.09,3.14,7.09,3.4c0,0.31-0.09,0.58-0.28,0.83
								C6.57,4.54,6.27,4.7,5.89,4.7c-0.1,0-0.18-0.02-0.23-0.05c-0.05-0.04-0.08-0.09-0.1-0.15C5.43,4.63,5.26,4.7,5.07,4.7
								c-0.2,0-0.37-0.07-0.5-0.21c-0.13-0.14-0.2-0.32-0.2-0.55c0-0.28,0.08-0.54,0.24-0.77c0.19-0.28,0.44-0.43,0.74-0.43
								c0.22,0,0.37,0.08,0.48,0.25l0.05-0.2h0.48L6.09,4.08C6.07,4.17,6.06,4.22,6.06,4.24c0,0.03,0.01,0.05,0.02,0.07
								c0.01,0.02,0.03,0.02,0.05,0.02c0.06,0,0.13-0.03,0.23-0.1c0.12-0.09,0.22-0.21,0.3-0.37c0.08-0.15,0.11-0.31,0.11-0.48
								c0-0.29-0.11-0.54-0.32-0.74c-0.22-0.2-0.52-0.3-0.9-0.3c-0.33,0-0.6,0.07-0.83,0.2C4.49,2.68,4.31,2.86,4.2,3.1
								C4.08,3.34,4.03,3.6,4.03,3.86c0,0.25,0.07,0.48,0.19,0.69C4.35,4.76,4.53,4.91,4.76,5c0.23,0.09,0.5,0.14,0.8,0.14
								c0.29,0,0.54-0.04,0.74-0.12c0.21-0.08,0.37-0.2,0.5-0.36h0.38C7.07,4.91,6.88,5.1,6.63,5.24C6.35,5.4,6,5.48,5.59,5.48
								c-0.4,0-0.74-0.07-1.03-0.2c-0.29-0.13-0.5-0.33-0.65-0.59C3.77,4.42,3.7,4.14,3.7,3.83C3.7,3.49,3.78,3.18,3.94,2.89z M0.38,4.17
								L4.4,6.85L0.38,9.95V4.17z M0.69,10.15l4.76-3.66l4.75,3.66H0.69z M10.5,9.95L6.49,6.85l4.02-2.68L10.5,9.95L10.5,9.95z M5.64,3.18
								c0.06,0.07,0.1,0.18,0.1,0.31c0,0.12-0.02,0.25-0.07,0.39C5.62,4.03,5.56,4.13,5.5,4.21C5.46,4.26,5.41,4.3,5.36,4.32
								C5.3,4.35,5.24,4.37,5.17,4.37C5.08,4.37,5,4.33,4.94,4.26C4.88,4.19,4.85,4.08,4.85,3.93c0-0.11,0.02-0.25,0.07-0.39
								c0.05-0.15,0.11-0.26,0.2-0.34C5.2,3.11,5.3,3.07,5.4,3.07C5.5,3.07,5.58,3.11,5.64,3.18z"/>
						</g>
					</svg>
					<span class="email">commerce@kursufa.ru</span>


				</div>


			</div>

				<div class="address">
					ИНН: 0278133451, ОГРН: 1070278002630<br>
					    Адрес: Россия, Республика Башкортостан, 450006, г. Уфа, <br>
						ул. Ленина, д. 156, корпус цокольный этаж №1, помещение 12
				</div>
		</div>

		</div>
	</div>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>
	.footer-container{
		background: rgb(153,153,153);
		background: linear-gradient(90deg, rgba(153,153,153,1) 0%, rgba(209,209,207,1) 100%);
		min-height: 100px;
	}

	.parent {
		display: grid;
		grid-template-columns: repeat(5, 1fr);
		grid-template-rows: 1fr 1fr;
		grid-column-gap: 10px;
		grid-row-gap: 0px;
		padding-bottom: 40px;
	}

	.div1 {
		grid-area: 1 / 1 / 2 / 2;
		color: #454440;
	}
	.div2 {
		grid-area: 1 / 2 / 2 / 3;
		padding-top: 20px;
	}
	.div3 {
		grid-area: 1 / 3 / 2 / 4;
		padding-top: 20px;
	}
	.div4 {
		grid-area: 1 / 4 / 2 / 5;
		padding-top: 20px;
	}
	.div5 {
		padding-top: 20px;
		grid-area: 1 / 5 / 2 / 6;
	}

	.div6 {
		grid-area: 2 / 2 / 3 / 5;
		text-align: center;
	}

	.address{
		padding: 20px;
		grid-area: 2 / 1 / 3 / 6;
		text-align: center;
		color: #F0F0EE;
		font-size: 16px;
		line-height: 30px;
	}

	.menu{
		color: white;
		text-transform: uppercase;
		margin-left: 60px;
		font-size: 16px !important;
	}

	.div2 > a{
		text-decoration: none;
	}
	.div3 > a{
		text-decoration: none;
	}
	.div4 > a{
		text-decoration: none;
	}

	h4 > a {
		color: #e0e0e0;
		text-decoration: none;
	}

	.st0{opacity:0.75;}
	.st1{fill:#010101;}

	.phone{
		color: black;
		margin-left: 6px;
		font-weight: bold;
		margin-top: 2px;
		font-size: 20px;
	}

	.opacity{
		opacity: 0.7;
	}

	.email{
		color: white;
		margin-left: 6px;
		font-weight: bold;
	}

	.footer-link {
		font-weight: normal;
	}
</style>